import { render, staticRenderFns } from "./Trivia.vue?vue&type=template&id=46a949c0&scoped=true&"
import script from "./Trivia.vue?vue&type=script&lang=js&"
export * from "./Trivia.vue?vue&type=script&lang=js&"
import style0 from "./Trivia.vue?vue&type=style&index=0&id=46a949c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a949c0",
  null
  
)

export default component.exports